module.exports = __webpack_public_path__ + "static/media/loading-intro-2.8351ae87.gif";